<template>
  <header class="header">
    <div class="header-logo-area" @click="gotoLink('/Main')">
      <img src="../assets/images/top-logo.png" width="126"/>
    </div>
    <!-- channeltok -->
    <div class="header-channeltok-area" >
      <div class="btn-channeltok" @click="openChannelTok">
        <img src="../assets/images/top-icon-channeltok.png" width="30" height="30"/>
        <button></button>
      </div>
    </div>
    <div class="header-icon-notice" @click="pushAlarmSlideView">
      <img src="../assets/images/top-icon-notice.png" width="25"/>
      <span>{{ alarmCnt }}</span>
    </div>
    <!-- right hamburger menu -->
    <div class="header-hamburger-menu-area">
      <div class="btn-hamburger" @click="menuSlideView">
        <button></button>
      </div>
    </div>
  </header>
</template>

<script>
import EventBus from "@/plugins/eventBus";
import ChannelService from "@/plugins/channelTok";

export default {
  name: 'MainHeader',
  props: ['headerType'],
  data() {
    return {
      alarmCnt: 0,
    }
  },
  // 계산된 속성
  computed: {
  },
  // 감시자
  watch: {},
  // $el 생성전
  created() {
    // 미확인 알람 개수 갱신
    EventBus.$off('push-alarm-func');
    EventBus.$on('push-alarm-func', () => {
      this.pushAlarmFunc();
    });
  },
  // $el 생성후
  mounted() {
    // 미확인 알람 개수
    this.pushAlarmFunc();
    this.loadChannelTalk();

  },
  methods: {
    // 미확인 알람 개수
    pushAlarmFunc() {
      let param = {};

      this.ajaxGetAuth('/api/v1/alarm/cnt', param, this.pushAlarmFuncResult);
    },
    // 미확인 알람 개수 결과
    pushAlarmFuncResult(response) {
      let result = response.result;
      if (result.code == 0) {
        this.alarmCnt = response.oAlarm.setting.nNoteReadCount;
      } else {
        this.toastMsg(result.resultNoti.message);
      }
    },
    // 내 알림 Slide
    pushAlarmSlideView() {
      const panel = this.$showPanel({
        component: () => import('../views/slide/Alarm'),
        openOn: 'right',
        width: screen.width,
      });
      panel.promise.then(result => {
        window.callbackBackKey = this.callbackBackKey;
        if (result == "close") {
          this.slidePanelClose(result);
        }
      });
    },
    // 메뉴 Slide
    menuSlideView() {
      let width = screen.width;
      if (screen.width >= 360) {
        width = parseInt((screen.width / 10) * 8);
      }
      const prevBackKeyEvent = window.callbackBackKey;
      const panel = this.$showPanel({
        component: () => import('@/views/slide/Menu'),
        openOn: 'right',
        width: width,
      });
      panel.promise.then(result => {
        window.callbackBackKey = prevBackKeyEvent;
        if (result == "close") {
          this.slidePanelClose(result);
        }
      });
    },
    openChannelTok() {
      this.loginCheck()
      ChannelService.show()
    },

    loginCheck() {
      if (!this.$store.state.authUserSId) {
        this.gotoLink('/login')
      }
    },
    loadChannelTalk() {
      if (process.env.VUE_APP_CHANNELTOK_KEY) {
        ChannelService.boot({
          pluginKey: process.env.VUE_APP_CHANNELTOK_KEY,
          memberId: this.$store.state.userId,
          mobileMessengerMode: "iframe",
          hideChannelButtonOnBoot: true,
          hidePopup : false,
          profile: {
            userName: this.$store.state.userName,
            // mobileNumber : "",
            CUSTOM_VALUE_1 : "모바일 커뮤니티",
          },
        });
      }
    }
  }
}
</script>

<style scoped>
/* Header */
.header-basic {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 132px;
  padding-top: env(safe-area-inset-top);
  background-color: #fff;
}

.header {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 60px;
  padding-top: env(safe-area-inset-top);
  background-color: #fff;
}

.header-logo-area {
  position: absolute;
  left: 20px;
  top: 16px;
  z-index: 1
}

.header:after {
  content: "";
  position: absolute;
  top: 0;
  background-image: url(../assets/images/top-bg.png);
  background-repeat: no-repeat;
  background-size: 257px 102px;
  background-position: top right;
  left: 0;
  right: 0;
  width: 100%;
  height: 102px;
}

.header-icon-notice {
  right: 60px;
  position: absolute;
  z-index: 1;
  top: 22px;
}

.header-icon-notice span {
  position: absolute;
  top: -9px;
  right: -9px;
  width: 19px;
  height: 19px;
  background-color: #ff3f56;
  border-radius: 100%;
  color: #fff;
  text-align: center;
  overflow: hidden;
  padding-top: 1px;
  font-size: 1rem;
}

.header-channeltok-area {
  right: 105px;
  position: absolute;
  z-index: 1;
  top: 15px;

}

/* s : Hamburger */
.header-hamburger-menu-area {
  right: 10px;
  position: absolute;
  z-index: 1;
  top: 15px;
}

.header-hamburger-menu-area .btn-hamburger {
}

.header-hamburger-menu-area .btn-hamburger button {
  width: 30px;
  height: 30px;
  background-image: url(../assets/images/btn-hamburger.png);
  background-repeat: no-repeat;
  background-size: 29px;
  background-color: #fff;
  border-radius: 5px;
  outline: unset
}

.header-hamburger-menu-area .btn-hamburger button:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.header-hamburger-menu-area .header-hamburger-navi-area {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: none;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  overflow: hidden;
}

/* e : Hamburger */


</style>
